var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "scout-form",
    {
      attrs: {
        "is-modified": !!_vm.from || !!_vm.to,
        label: "送信日",
        half: "",
      },
    },
    [
      _c("term-select", {
        attrs: { from: _vm.from, to: _vm.to, "no-option": "" },
        on: {
          "update:from": function ($event) {
            return _vm.$emit("update:from", $event)
          },
          "update:to": function ($event) {
            return _vm.$emit("update:to", $event)
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }